import React, { useContext } from 'react'
import { Logout } from '@/api/endpoints'
import { forceLogout } from '../../api/service'
import { PrivilegeContext } from '../../context/PrivilegesContext'
import { Block } from '../../components/crRender'
import { useTranslation } from 'react-i18next'
import { Icon } from '@iconify/react/dist/iconify.js'
import { useNavigate } from 'react-router-dom'

const ActionMenu = ({ userTab }) => {

    const { t } = useTranslation()

    const logout = () => {
        Logout().then(result => {
            forceLogout()
        })
    }
    return (
        <Block isRender={userTab} className={"user-settings-menu"}>
            <div className='logOut' onClick={logout}>
                <span className='HeaderText'>
                    {t("logout")}
                </span>
                <Icon icon="lucide:door-open" className='Icon' />
            </div>
        </Block>
    )
}

export default ActionMenu